"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerWithFooter = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const React = __importStar(require("react"));
const footerHeight = "30px";
const FooterInformationBar = styled_components_1.default.div `
  width: 100%;
  background-color: #a9a9a9;
  color: #f5f5f5;
  font-size: 12pt;
  height: ${footerHeight};
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-shrink: 0;
`;
const MainContent = styled_components_1.default.div `
  flex: auto;
  position: relative;
  padding-bottom: ${footerHeight};
  overflow-y: auto;
`;
const Wrapper = styled_components_1.default.div `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
`;
const ContainerWithFooter = (props) => {
    const childArray = props.children;
    return (React.createElement(Wrapper, null,
        React.createElement(MainContent, null, childArray[0]),
        React.createElement(FooterInformationBar, null, childArray[1])));
};
exports.ContainerWithFooter = ContainerWithFooter;
//# sourceMappingURL=container-with-footer.js.map